"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function listMissingPropertiesFrom(obj, _a) {
    var requiredProperties = _a.requiredProperties;
    return requiredProperties.reduce(function (acc, cur) {
        if (obj.hasOwnProperty(cur)) {
            return acc;
        }
        acc.push(cur);
        return acc;
    }, []);
}
exports.default = listMissingPropertiesFrom;
//# sourceMappingURL=listMissingProperties.js.map